import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['internalAction'];

  private disabled = false;

  connect() {
    document.addEventListener('visibilitychange', () => {
      this.disabled = false;
    });
  }

  executePrimaryAction(e: KeyboardEvent) {
    if (this.isInternalAction(e.target as HTMLElement)) {
      return;
    }

    if ((this.isClick(e) || this.isEnterKeydown(e)) && !this.disabled) {
      this.disabled = true;
      this.submitLink();
    }
  }

  submitLink() {
    const link = document.createElement('a');
    link.href = this.path;
    link.dataset.testid = 'action-card-link';
    link.dataset.method = this.method;
    if (this.data.get('remote')) link.dataset.remote = 'true';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
  }

  isInternalAction(target: HTMLElement) {
    // @ts-ignore Cannot declare the type for internalActionTargets bc it is readonly in the base class
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    return this.internalActionTargets.some(internalActionTarget => internalActionTarget.contains(target));
  }

  isClick(event: Event) {
    return event.type === 'click';
  }

  isEnterKeydown(event: KeyboardEvent) {
    return event.type === 'keydown' && (event.code === 'Enter' || event.keyCode === 13);
  }

  get path() {
    return this.data.get('path') || '';
  }

  get method() {
    return this.data.get('method') || '';
  }
}
